import postRobot from 'post-robot';
import { AppContext, Context, ContextCancellables, DeploymentInfo, ServiceInfo, UserInfo } from './types';
import { MICROSCOPE_ENDPOINT } from './config';

export const buildContext = (opts?: { domain?: string; window?: Window }): Context => {
  const send = <T>(name: keyof Context) => {
    const win = opts?.window ?? window.parent;
    const options = opts?.domain ? { domain: opts.domain } : undefined;

    return postRobot.send(win, `context.${name}`, {}, options).then((res) => res.data as T);
  };

  const getCurrentUser = () => {
    return send<UserInfo>('getCurrentUser');
  };

  const getCurrentEnv = () => {
    return send<string>('getCurrentEnv');
  };

  const getServiceInfo = () => {
    return send<ServiceInfo>('getServiceInfo');
  };

  const getDeploymentInfo = () => {
    return send<DeploymentInfo>('getDeploymentInfo');
  };

  const getAppContext = () => {
    return send<AppContext>('getAppContext');
  };

  return {
    getCurrentUser,
    getCurrentEnv,
    getServiceInfo,
    getDeploymentInfo,
    getAppContext,
  };
};

export const setupContextTrap = (handlers: Context, opts?: { domain?: string; name?: string }): ContextCancellables => {
  const options = {
    ...(opts?.domain ? { domain: opts?.domain } : {}),
  };

  const getCurrentUser = postRobot.on(`context.getCurrentUser`, options, () => handlers.getCurrentUser());
  const getServiceInfo = postRobot.on(`context.getServiceInfo`, options, () => handlers.getServiceInfo());
  const getDeploymentInfo = postRobot.on(`context.getDeploymentInfo`, options, () => handlers.getDeploymentInfo());
  const getAppContext = postRobot.on(`context.getAppContext`, options, () => handlers.getAppContext());
  const getCurrentEnv = postRobot.on(`context.getCurrentEnv`, options, () => handlers.getCurrentEnv());

  return {
    getCurrentUser,
    getServiceInfo,
    getDeploymentInfo,
    getAppContext,
    getCurrentEnv,
  };
};

export const context = buildContext({ domain: MICROSCOPE_ENDPOINT });
